import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    width: '100%'
  } satisfies SxProps<Theme>,
  paper: {
    mb: 3
  } satisfies SxProps<Theme>,
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 2
  } satisfies SxProps<Theme>,
  title: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    wordBreak: 'break-word',
    minWidth: 0
  } satisfies SxProps<Theme>,
  questionWrapper: {
    mb: 2
  } satisfies SxProps<Theme>,
  addButton: {
    textTransform: 'none',
    mt: 1
  } satisfies SxProps<Theme>
}
